import { action } from '../../../lib/api';

export const setModalState = (key, value) => {
  action('SET_MODAL_OPEN', { [key]: value });
};

export const registerModal = (modalId) => ({
  type: 'REGISTER_MODAL',
  payload: modalId
});

export const unregisterModal = (modalId) => ({
  type: 'UNREGISTER_MODAL',
  payload: modalId
});
